import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { AlbumDataWithParentAndSubscription } from '../../graphql/queries/albums';
import PurchaseAlbumFaces from '../../components/purchase/PurchaseAlbumFaces';

const withAlbumData = graphql(AlbumDataWithParentAndSubscription, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumId,
    },
  }),
  props: ({ data: { album } }) => ({
    album,
  }),
});

const mapStateToProps = ({ purchaseAlbum }) => ({
  selectedIdentitiesForPurchase: purchaseAlbum.identitiesForPurchase,
  selectedIdentitiesForJoin: purchaseAlbum.identitiesForJoin,
});

export default compose(
  withRouter,
  withAlbumData,
  connect(mapStateToProps),
)(PurchaseAlbumFaces);
